import { useEffect, useState } from "react";
import { get_return_policy } from '../../../api/category_product/Category_Product';
import parse from "html-react-parser";
import Header from "../../common/header/Header";
import Footer from "../../common/footer/Footer";
import Loader from "../../../loader/Loader";
import Home_Private_Confidential from "../home_page_components/home_private_confidential/Home_Private_Confidential";
import { Helmet } from "react-helmet";
import { WEB_DOMAIN_KEY } from "../../../config/Config";

export const Return_Policy = () => {
    const [get_return_policy_list, set_Return_Policy_List] = useState();
    const [is_loading, set_Is_Loading] = useState(false);

    useEffect(() => {
        set_Is_Loading(true);
        const handle_get_return_policy = async () => {
            try {
                const response = await get_return_policy();
                set_Return_Policy_List(response?.data?.data);
            }
            catch (error) {
                console.error("error", error)
            } finally {
                set_Is_Loading(false);
            }
        }
        handle_get_return_policy();
    }, [])

    const returnPolicy = get_return_policy_list?.find(
        (type) => type?.page_type === "return_policy"
    );

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <title>{returnPolicy?.meta_title}</title>
                <meta name="description" content={returnPolicy?.meta_description
                    || "description"} />

                <link rel="canonical" href={`${WEB_DOMAIN_KEY}return-policy`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}return-policy`} />

            </Helmet>
            <Header />
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <section className="gi-category py-[40px] max-[767px]:p-[15px]">
                        <div
                            className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                            <div className="custome_viewbox px-8">
                                <div className="w-full gi-grid-list">
                                    <h1 className="text-2xl font-bold mb-4">Return Policy</h1>
                                </div>
                                <div className="sub__title">
                                    {returnPolicy?.description
                                        ? parse(returnPolicy.description)
                                        : "No return policy found."}
                                </div>

                            </div>
                         
                        </div>
                    </section >
                )}
            <Home_Private_Confidential />
            <Footer />
        </>
    );
}